import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isEmpty, toArray } from 'lodash';

@Component({
  selector: 'app-import-confirm-modal',
  templateUrl: './import-confirm-modal.component.html',
  styleUrls: ['./import-confirm-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportConfirmModalComponent implements OnInit {

  data: any;
  allColumns: string[] = ['imported', 'updated', 'duplicatedCount', 'disable', 'failed', 'missing_headers', 'invalid_headers', 'extra_headers', 'total'];
  displayedColumns: string[] = [];

  constructor(
    public matDialogRef: MatDialogRef<ImportConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
  ) {
    if (!isEmpty(this._data)) {
      this.data = this._data.data;
    }
  }

  ngOnInit(): void {
    this.initializeColumns(this.data);
  }
  
  initializeColumns(data: any[]): void {
    if (data.length > 0) {
      const keys = Object.keys(data[0]);
      this.displayedColumns = this.allColumns.filter(column => keys.includes(column));
    }
  }

}
